/* eslint-disable @typescript-eslint/no-empty-function */
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSTKContext } from '@/context/context';
import { useModifierPriceDeviations } from '@/services/modifiers/modifiers.service';
import { PriceDeviationsDrawerShared } from '@/pages/Franchisee/SharedComponents/PriceDeviations/PriceDeviationsDrawerShared';
import { ModifierPriceDeviationsDrawerProps } from './ModifierPriceDeviationsDrawerProps.types';
import {
  expandIngredientStatusDeviations,
  isModifierCategoryIngredientsPresence,
} from '@/pages/Franchisee/Menus/StoreMenuModifiersDetails/modifierDisplay.helpers';

export const ModifierPriceDeviationsDrawer: FC<ModifierPriceDeviationsDrawerProps> = ({
  isOpen,
  onClose,
  modifierCategory,
  modifierKeys,
  selectedGroupName,
  cameFromEditDrawer,
}) => {
  const { t } = useTranslation();
  const { storesAndGroups } = useSTKContext();
  const isIngredientsAvailability = isModifierCategoryIngredientsPresence(modifierCategory);

  const selectedStores =
    storesAndGroups?.origin === 'tab-stores-groups'
      ? storesAndGroups.storeGroups?.find((item) => item.storeGroup === selectedGroupName)?.stores || []
      : storesAndGroups?.stores?.filter((item) => item.storeGroup === selectedGroupName).map((item) => item.storeNo) ||
        [];

  const { data: priceDeviations = [], isLoading } = useModifierPriceDeviations(
    true,
    modifierCategory,
    selectedStores,
    modifierKeys ?? [],
  );

  const availabilityData = isIngredientsAvailability
    ? expandIngredientStatusDeviations(priceDeviations, selectedStores)
    : undefined;

  if (isIngredientsAvailability) {
    return (
      <PriceDeviationsDrawerShared
        isOpen={isOpen}
        onClose={onClose}
        selectedGroupName={selectedGroupName}
        availabilityData={availabilityData}
        isLoading={isLoading}
        cameFromEditDrawer={cameFromEditDrawer}
        mode="availability"
        title={t('priceDeviations.modifierDeviations')}
        firstColumnHeader={t('priceDeviations.table.modifier')}
        deviationsByStoreHeader={t('priceDeviations.table.availabilityByStore')}
      />
    );
  }

  return (
    <PriceDeviationsDrawerShared
      isOpen={isOpen}
      onClose={onClose}
      selectedGroupName={selectedGroupName}
      data={priceDeviations}
      isLoading={isLoading}
      cameFromEditDrawer={cameFromEditDrawer}
    />
  );
};
